import { LEADERSHIP } from "../lib/constants";

export const Leadership = () => {
  return (
    <section
      id="leadership"
      data-testid="leadership-section"
      className="relative bg-[#FDFBF7] py-20 md:py-32 border-t border-[#0B2545]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16 reveal">
          <div className="flex items-center gap-4">
            <span className="gold-line" />
            <h2 className="font-sans text-[#0B2545] uppercase text-3xl md:text-4xl lg:text-5xl tracking-widest-2 font-semibold">
              Leadership
            </h2>
          </div>
        </div>

        <div
          className="grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[#0B2545]/10"
          data-testid="leadership-grid"
        >
          {LEADERSHIP.map((p, i) => (
            <article
              key={p.name}
              data-testid={`leader-${i}`}
              className="relative bg-white group reveal hover:bg-[#0B2545] transition-colors duration-500 flex flex-col"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              {/* Portrait */}
              <div className="relative aspect-[4/5] overflow-hidden bg-[#0B2545]">
                <img
                  src={p.photo}
                  alt={`${p.name} — ${p.role}`}
                  style={p.photoPosition ? { objectPosition: p.photoPosition } : undefined}
                  className={`w-full h-full object-cover transition-transform duration-[1100ms] group-hover:scale-105 ${
                    i === 0 ? "grayscale-[15%] sepia-[10%]" : ""
                  }`}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#061426]/30 via-transparent to-transparent opacity-60 group-hover:opacity-30 transition-opacity duration-500" />
                <span className="absolute top-4 left-4 w-8 h-px bg-[#C8A24A]" />
              </div>

              <div className="p-6 md:p-7 flex-1 flex flex-col">
                <h3 className="font-serif text-[#0B2545] group-hover:text-white text-xl leading-tight mb-1 transition-colors duration-500">
                  {p.name}
                </h3>
                {p.altName && (
                  <p className="font-serif italic text-[#C8A24A] text-sm mb-3">
                    {p.altName}
                  </p>
                )}
                <div className="font-sans text-[#C8A24A] uppercase text-[10px] tracking-widest-2 mb-4">
                  {p.role}
                </div>
                {p.note && (
                  <p className="font-sans text-[#061426] group-hover:text-white/85 text-sm leading-relaxed transition-colors duration-500 mt-auto">
                    {p.note}
                  </p>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
